import api from './ApiService';

interface LayoutDispatchParams {
  url?: string;
  name?: string;
  pageName?: string;
  allKeys?: boolean;
}

export function layoutDispatch(method: LayoutDispatchParams = {}) {
  if (!method.name && !method.url) {
    console.warn('No method name given', method);
  }

  if (method.url) {
    return api.post(`${method.url}?pageName=${method.pageName}`, method);
  }

  const methodName = method.name || 'EMPTY';

  if (method.allKeys) {
    return api.post(`/layout/dispatch/${methodName.toUpperCase()}?allKeys=true&pageName=${method.pageName}`, method);
  }

  // TODO Get rid of GET method
  return api.get(`/layout/dispatch/${methodName.toUpperCase()}`, { params: method });
}
